import { useIsFeedbackEnabled } from '@ms/yammer-hooks/dist/ocps';

import type { UseUIFeatureCheck } from '../types';

export const useIsUserFeedbackEnabled: UseUIFeatureCheck = () => useIsFeedbackEnabled('UserFeedbackFormEnabled');
